const PENDING_STATUSES = new Set(["pending", "confirmed"]);

const normalizeStatus = (value) => String(value || "").toLowerCase();

const isStillUnserved = (item) =>
  !["served", "cancelled"].includes(normalizeStatus(item?.status));

export const buildRhodePendingOrderPayload = (order = {}) => {
  const dispatchKind = String(order.dispatchKind || order.dispatch_kind || "")
    .trim()
    .toLowerCase();
  const dispatchEventId = Number(
    order.dispatchEventId || order.dispatch_event_id,
  );
  const eventAnnouncement =
    Number.isInteger(dispatchEventId) &&
    dispatchEventId > 0 &&
    ["claim", "addition"].includes(dispatchKind);
  const announcementKey = eventAnnouncement
    ? `dispatch:${dispatchEventId}`
    : String(order.id || "").trim();
  if (!announcementKey || (order.status === "held" && !eventAnnouncement)) {
    return null;
  }

  const items = (Array.isArray(order.items) ? order.items : []).filter(
    (item) => {
      if (eventAnnouncement) {
        if (
          Number(item?.dispatchEventId || item?.dispatch_event_id) !==
          dispatchEventId
        ) {
          return false;
        }
        return isStillUnserved(item);
      }
      return PENDING_STATUSES.has(normalizeStatus(item?.status));
    },
  );
  if (items.length === 0) return null;

  return {
    announcementKey,
    tableNumber: order.table || null,
    context: order.context || null,
    orderType: order.orderType || order.order_type || null,
    serverName: order.serverName || order.server_name || null,
    dispatchKind: eventAnnouncement ? dispatchKind : null,
    dispatchEventId: eventAnnouncement ? dispatchEventId : null,
    dispatchActorName:
      order.dispatchActorName || order.dispatch_actor_name || null,
    isDelivery: Boolean(order.isDelivery || order.is_delivery),
    deliveryMode: order.deliveryMode || order.delivery_mode || null,
    deliveryMethod: order.deliveryMethod || order.delivery_method || null,
    isRepeatTable: Boolean(order.isRepeatTable || order.is_repeat_table),
    items,
    courseId: order.courseId || order.course_id || null,
    courseNumber: order.courseNumber || order.course_number || null,
    upcomingItemCount: Math.max(
      0,
      Number(order.upcomingItemCount || order.upcoming_item_count) || 0,
    ),
    upcomingCourseCount: Math.max(
      0,
      Number(order.upcomingCourseCount || order.upcoming_course_count) || 0,
    ),
  };
};

export const buildRhodePendingOrderPayloads = (orders = []) =>
  (Array.isArray(orders) ? orders : [])
    .map(buildRhodePendingOrderPayload)
    .filter(Boolean);
